import { AxiosRequestConfig } from 'axios';
import { v4 as uuidv4 } from 'uuid';

export function correlationIdHeader(config: AxiosRequestConfig): AxiosRequestConfig {
	const xCorrelationId = {
		'X-Correlation-Id': uuidv4()
	};
	config.headers = { ...config.headers, ...xCorrelationId };
	return config;
}
